import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface AuthShellProps {
  children: ReactNode;
  showBack?: boolean;
  backTo?: string;
  backLabel?: string;
}

const AuthShell: React.FC<AuthShellProps> = ({
  children,
  showBack = false,
  backTo = '/login',
  backLabel = 'Back',
}) => {
  return (
    <div className="auth-page relative min-h-screen overflow-hidden bg-[#0a0a0c] text-white">
      {/* Ambient glow orbs — #930dc5 bottom-left, #ee377f top-right */}
      <div className="auth-orb auth-orb--bl" aria-hidden="true" />
      <div className="auth-orb auth-orb--tr" aria-hidden="true" />
      <div className="auth-grain" aria-hidden="true" />

      {showBack && (
        <Link to={backTo} className="auth-back-btn">
          <ChevronLeft size={16} strokeWidth={2.5} />
          <span>{backLabel}</span>
        </Link>
      )}

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-12">
        {children}
      </div>
    </div>
  );
};

export default AuthShell;
